import {gsap} from "gsap";

import {SlowMo} from "gsap/EasePack";

import {ScrollTrigger} from "gsap/ScrollTrigger";



gsap.registerPlugin(ScrollTrigger);




gsap.to('.blob', {
    x: 200,
    rot: 360,
    duration: 3,
    scrollTrigger: {
        trigger: '.moving-text',
    }
});

/*gsap.from('.icon', {
    y: -200,
    scrollTrigger: {
        trigger: '.scroll-trigger',
        scrub: true,
    }
});*/


gsap.from('.tear', {
    x: 2000,
    scrollTrigger: {
        trigger: '.featured-projects',
        scrub: true,

    }
});
